/**
 * Created by roman.kupin on 20/08/2014.
 */


angular
    .module("flipto.components.campaigns", ['pascalprecht.translate', 'flipto.core.lodash', 'flipto.core.calculate']);